import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { contentHeaders } from './headers';
import 'rxjs/add/operator/map';
import 'rxjs/operator/delay';
import 'rxjs/operator/mergeMap';
import 'rxjs/operator/switchMap';
import 'rxjs';
import { environment } from '../../../environments/environment';
import { VTService } from './vt.service';

@Injectable()
export class UserSession {
    remotePosts = new BehaviorSubject([]);
    _router;


    public baseUrl: string = environment.serverURL;

    public org_id = "F8CEDE33-DFB1-4A9E-AFD1-E8B3BD70EBFC";
    public drivers = [];
    public vehicles = [];
    public accounts = [];
    public user_name = "";
    public user_id = 0;
    public email_id = "";
    public user_role = "";
    public user_fname = "";
    public user_lname = "";
    public loginname = "";
    public token = "";
    public isSSO=false;
    public zubielocationevents = [];
    constructor(public http: HttpClient, router: Router, public vtservice: VTService) {
        this._router = router;
    }
    setDefaults() {
        this.org_id = "F8CEDE33-DFB1-4A9E-AFD1-E8B3BD70EBFC";
        this.user_id = 0
        this.user_fname = "guest"
        this.user_lname = "";
        this.loginname = "guest";
        this.user_name = "guest";
        this.user_role = "superadmin"
        this.isSSO=false
    }
    getAccountName(accountid) {
        let nickname = "";
        if (accountid !== null && accountid !== undefined) {
            let arracc = accountid.split(",")
            if (arracc.length > 0) {
                let nname = []
                arracc.forEach(el => {
                    let accnname = this.accounts.filter(rval => rval.accountid === el);
                    if (accnname.length > 0) {
                        nname.push(accnname[0].nickname === null ? 'NA' : accnname[0].nickname);
                    }
                });
                nickname = nname.join(",");
            }
        } else {
            nickname = "LAB";
        }
        return nickname;
    }
    getCurrentDriverLocation(vehiclenickname) {
        let rtnLoc;
        let loc = this.zubielocationevents.filter(rval => rval.nickname.toLowerCase() === vehiclenickname.toLowerCase());
        if (loc.length > 0) {
            rtnLoc = loc[0].path[loc[0].path.length - 1]
        }
        return rtnLoc;
    }
    getDriverName(driverid) {
        let rtnDrv = '';
        let drv = this.drivers.filter(rval => rval.userid === driverid)
        if (drv.length > 0) {
            rtnDrv = drv[0].firstname + ' ' + drv[0].lastname;
        }
        return rtnDrv;
    }
    getDrivername_Login(loginname) {
        let rtnDrv = '';
        let drv = this.drivers.filter(rval => rval.loginname === loginname)
        if (drv.length > 0) {
            rtnDrv = drv[0].firstname + ' ' + drv[0].lastname;
        }
        else {
            rtnDrv = loginname;
        }
        return rtnDrv;
    }
}